// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout.css - Glassmorphism Dark Theme */

.layout-container {
  display: flex;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Sidebar - Glassmorphism Design */
.sidebar {
  background: rgba(2, 6, 23, 0.75);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--white);
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.3);
  position: relative;
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: 100;
}

.sidebar::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(226, 232, 240, 0.12) 0%,
    rgba(241, 245, 249, 0.08) 50%,
    rgba(248, 250, 252, 0.06) 100%
  );
  pointer-events: none;
  z-index: -1;
}

.sidebar-header {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.sidebar-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-toggle {
  background: rgba(226, 232, 240, 0.18);
  border: 1px solid rgba(226, 232, 240, 0.35);
  color: var(--primary-light);
  padding: 0.6rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.sidebar-toggle:hover {
  background: rgba(226, 232, 240, 0.28);
  border-color: rgba(241, 245, 249, 0.5);
  transform: scale(1.05);
}

.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Scrollbar styling */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.02);
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(226, 232, 240, 0.4);
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(226, 232, 240, 0.6);
}

.nav-item {
  display: block;
  text-decoration: none;
  color: rgba(226, 232, 240, 0.75);
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
  position: relative;
  margin: 0.25rem 0.5rem;
  border-radius: 12px;
}

.nav-item-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  z-index: 1;
}

.nav-icon {
  font-size: 1.25rem;
  min-width: 1.25rem;
  color: var(--primary-light);
  transition: all 0.3s ease;
}

.nav-text {
  white-space: nowrap;
  font-weight: 500;
  transition: all 0.3s ease;
}

.nav-item:hover {
  background: rgba(226, 232, 240, 0.12);
  color: var(--white);
}

.nav-item:hover .nav-icon {
  color: #f1f5f9;
  transform: scale(1.1);
}

.nav-item.active {
  background: linear-gradient(
    90deg,
    rgba(226, 232, 240, 0.18),
    rgba(241, 245, 249, 0.12)
  );
  color: var(--white);
  position: relative;
  border: 1px solid rgba(226, 232, 240, 0.3);
}

.nav-item.active .nav-icon {
  color: #f1f5f9;
}

.active-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(
    180deg,
    #cbd5e1,
    #f1f5f9
  );
  border-radius: 0 4px 4px 0;
  box-shadow: 0 0 12px rgba(226, 232, 240, 0.6);
}

/* Dropdown styles */
.dropdown-header {
  cursor: pointer;
}

.dropdown-header.open {
  background: rgba(226, 232, 240, 0.1);
}

.submenu-item {
  font-size: 0.95rem;
  padding: 0.6rem 1.5rem;
}

.submenu-item .nav-icon {
  font-size: 1rem;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(226, 232, 240, 0.12);
  border: 1px solid rgba(226, 232, 240, 0.25);
  border-radius: 12px;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: rgba(226, 232, 240, 0.18);
  border-color: rgba(226, 232, 240, 0.4);
}

.user-icon {
  font-size: 1.25rem;
  color: var(--primary-light);
}

.username {
  font-weight: 600;
  white-space: nowrap;
  color: rgba(226, 232, 240, 0.9);
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  font-weight: 500;
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
  color: #fef2f2;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

/* Collapsed sidebar state */
.sidebar.closed .nav-item {
  padding: 0.75rem;
  display: flex;
  justify-content: center;
}

.sidebar.closed .nav-icon {
  font-size: 1.5rem;
}

.sidebar.closed .user-info,
.sidebar.closed .logout-btn {
  justify-content: center;
}

/* Main Content */
.main-content {
  flex: 1 1;
  padding: 2rem;
  overflow-y: auto;
  position: relative;
  background: transparent;
}

/* Custom scrollbar for main content */
.main-content::-webkit-scrollbar {
  width: 8px;
}

.main-content::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.3);
}

.main-content::-webkit-scrollbar-thumb {
  background: rgba(226, 232, 240, 0.4);
  border-radius: 4px;
}

.main-content::-webkit-scrollbar-thumb:hover {
  background: rgba(226, 232, 240, 0.6);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1000;
    transform: translateX(-100%);
    box-shadow: none;
  }

  .sidebar.open {
    transform: translateX(0);
    box-shadow: 8px 0 32px rgba(0, 0, 0, 0.5);
  }

  .main-content {
    margin-left: 0;
    padding: 1.5rem;
  }

  /* Mobile overlay when sidebar is open */
  .sidebar.open::after {
    content: '';
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
}

/* Tablet */
@media (max-width: 992px) {
  .main-content {
    padding: 1.75rem;
  }
}

/* Badge/Counter styling for shop orders */
.nav-item-content span[style*="position: absolute"] {
  animation: pulse 2s infinite;
}

@keyframes badgePulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .sidebar {
  background: rgba(255, 255, 255, 0.95);
  border-right: 1px solid rgba(15, 23, 42, 0.1);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);
}

[data-theme="light"] .sidebar::before {
  background: linear-gradient(
    180deg,
    rgba(100, 116, 139, 0.05) 0%,
    rgba(148, 163, 184, 0.03) 50%,
    rgba(203, 213, 225, 0.02) 100%
  );
}

[data-theme="light"] .sidebar-title {
  background: linear-gradient(135deg, #475569 0%, #64748b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="light"] .nav-item {
  color: rgba(30, 41, 59, 0.75);
}

[data-theme="light"] .nav-item:hover {
  background: rgba(100, 116, 139, 0.08);
  color: #0f172a;
}

[data-theme="light"] .nav-item.active {
  background: linear-gradient(
    90deg,
    rgba(100, 116, 139, 0.12),
    rgba(148, 163, 184, 0.08)
  );
  color: #0f172a;
  border: 1px solid rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .nav-icon {
  color: #64748b;
}

[data-theme="light"] .nav-item:hover .nav-icon,
[data-theme="light"] .nav-item.active .nav-icon {
  color: #475569;
}

[data-theme="light"] .user-info {
  background: rgba(100, 116, 139, 0.08);
  border: 1px solid rgba(100, 116, 139, 0.15);
}

[data-theme="light"] .user-info:hover {
  background: rgba(100, 116, 139, 0.12);
  border-color: rgba(100, 116, 139, 0.25);
}

[data-theme="light"] .username {
  color: #1e293b;
}

[data-theme="light"] .main-content::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .main-content::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Layout.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,yFAAyF;EACzF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;;;;GAIC;EACD,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV;;;;GAIC;EACD,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,WAAW;IACX,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,oDAAoD;AACpD;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Layout.css - Glassmorphism Dark Theme */\n\n.layout-container {\n  display: flex;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Sidebar - Glassmorphism Design */\n.sidebar {\n  background: rgba(2, 6, 23, 0.75);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  color: var(--white);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.3);\n  position: relative;\n  transition: width 0.3s ease;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.sidebar::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(226, 232, 240, 0.12) 0%,\n    rgba(241, 245, 249, 0.08) 50%,\n    rgba(248, 250, 252, 0.06) 100%\n  );\n  pointer-events: none;\n  z-index: -1;\n}\n\n.sidebar-header {\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.sidebar-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  white-space: nowrap;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.sidebar-toggle {\n  background: rgba(226, 232, 240, 0.18);\n  border: 1px solid rgba(226, 232, 240, 0.35);\n  color: var(--primary-light);\n  padding: 0.6rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(226, 232, 240, 0.28);\n  border-color: rgba(241, 245, 249, 0.5);\n  transform: scale(1.05);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n/* Scrollbar styling */\n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(226, 232, 240, 0.4);\n  border-radius: 3px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(226, 232, 240, 0.6);\n}\n\n.nav-item {\n  display: block;\n  text-decoration: none;\n  color: rgba(226, 232, 240, 0.75);\n  padding: 0.75rem 1.5rem;\n  transition: all 0.3s ease;\n  position: relative;\n  margin: 0.25rem 0.5rem;\n  border-radius: 12px;\n}\n\n.nav-item-content {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  position: relative;\n  z-index: 1;\n}\n\n.nav-icon {\n  font-size: 1.25rem;\n  min-width: 1.25rem;\n  color: var(--primary-light);\n  transition: all 0.3s ease;\n}\n\n.nav-text {\n  white-space: nowrap;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.nav-item:hover {\n  background: rgba(226, 232, 240, 0.12);\n  color: var(--white);\n}\n\n.nav-item:hover .nav-icon {\n  color: #f1f5f9;\n  transform: scale(1.1);\n}\n\n.nav-item.active {\n  background: linear-gradient(\n    90deg,\n    rgba(226, 232, 240, 0.18),\n    rgba(241, 245, 249, 0.12)\n  );\n  color: var(--white);\n  position: relative;\n  border: 1px solid rgba(226, 232, 240, 0.3);\n}\n\n.nav-item.active .nav-icon {\n  color: #f1f5f9;\n}\n\n.active-indicator {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: linear-gradient(\n    180deg,\n    #cbd5e1,\n    #f1f5f9\n  );\n  border-radius: 0 4px 4px 0;\n  box-shadow: 0 0 12px rgba(226, 232, 240, 0.6);\n}\n\n/* Dropdown styles */\n.dropdown-header {\n  cursor: pointer;\n}\n\n.dropdown-header.open {\n  background: rgba(226, 232, 240, 0.1);\n}\n\n.submenu-item {\n  font-size: 0.95rem;\n  padding: 0.6rem 1.5rem;\n}\n\n.submenu-item .nav-icon {\n  font-size: 1rem;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(226, 232, 240, 0.12);\n  border: 1px solid rgba(226, 232, 240, 0.25);\n  border-radius: 12px;\n  margin-bottom: 1rem;\n  transition: all 0.3s ease;\n}\n\n.user-info:hover {\n  background: rgba(226, 232, 240, 0.18);\n  border-color: rgba(226, 232, 240, 0.4);\n}\n\n.user-icon {\n  font-size: 1.25rem;\n  color: var(--primary-light);\n}\n\n.username {\n  font-weight: 600;\n  white-space: nowrap;\n  color: rgba(226, 232, 240, 0.9);\n}\n\n.logout-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.logout-btn:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #fef2f2;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n/* Collapsed sidebar state */\n.sidebar.closed .nav-item {\n  padding: 0.75rem;\n  display: flex;\n  justify-content: center;\n}\n\n.sidebar.closed .nav-icon {\n  font-size: 1.5rem;\n}\n\n.sidebar.closed .user-info,\n.sidebar.closed .logout-btn {\n  justify-content: center;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  overflow-y: auto;\n  position: relative;\n  background: transparent;\n}\n\n/* Custom scrollbar for main content */\n.main-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.main-content::-webkit-scrollbar-track {\n  background: rgba(15, 23, 42, 0.3);\n}\n\n.main-content::-webkit-scrollbar-thumb {\n  background: rgba(226, 232, 240, 0.4);\n  border-radius: 4px;\n}\n\n.main-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(226, 232, 240, 0.6);\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 1000;\n    transform: translateX(-100%);\n    box-shadow: none;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n    box-shadow: 8px 0 32px rgba(0, 0, 0, 0.5);\n  }\n\n  .main-content {\n    margin-left: 0;\n    padding: 1.5rem;\n  }\n\n  /* Mobile overlay when sidebar is open */\n  .sidebar.open::after {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: -1;\n  }\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  .main-content {\n    padding: 1.75rem;\n  }\n}\n\n/* Badge/Counter styling for shop orders */\n.nav-item-content span[style*=\"position: absolute\"] {\n  animation: pulse 2s infinite;\n}\n\n@keyframes badgePulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .sidebar {\n  background: rgba(255, 255, 255, 0.95);\n  border-right: 1px solid rgba(15, 23, 42, 0.1);\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);\n}\n\n[data-theme=\"light\"] .sidebar::before {\n  background: linear-gradient(\n    180deg,\n    rgba(100, 116, 139, 0.05) 0%,\n    rgba(148, 163, 184, 0.03) 50%,\n    rgba(203, 213, 225, 0.02) 100%\n  );\n}\n\n[data-theme=\"light\"] .sidebar-title {\n  background: linear-gradient(135deg, #475569 0%, #64748b 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"light\"] .nav-item {\n  color: rgba(30, 41, 59, 0.75);\n}\n\n[data-theme=\"light\"] .nav-item:hover {\n  background: rgba(100, 116, 139, 0.08);\n  color: #0f172a;\n}\n\n[data-theme=\"light\"] .nav-item.active {\n  background: linear-gradient(\n    90deg,\n    rgba(100, 116, 139, 0.12),\n    rgba(148, 163, 184, 0.08)\n  );\n  color: #0f172a;\n  border: 1px solid rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .nav-icon {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .nav-item:hover .nav-icon,\n[data-theme=\"light\"] .nav-item.active .nav-icon {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .user-info {\n  background: rgba(100, 116, 139, 0.08);\n  border: 1px solid rgba(100, 116, 139, 0.15);\n}\n\n[data-theme=\"light\"] .user-info:hover {\n  background: rgba(100, 116, 139, 0.12);\n  border-color: rgba(100, 116, 139, 0.25);\n}\n\n[data-theme=\"light\"] .username {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .main-content::-webkit-scrollbar-thumb {\n  background: rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .main-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(100, 116, 139, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
